import useDevice from 'hooks/DesktopDevice.hook';
import { Stack, Typography } from 'styles';
import { useTranslation } from 'utils/translations';
import { claimListRowSX } from './PaymentClaimsList.component';

const PaymentClaimsHeader = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { isDesktop } = useDevice();

	const headerTypographySX = { minWidth: '100px', maxWidth: '100px' };

	return (
		<Stack
			direction={'row'}
			width={!isDesktop ? 'fit-content' : '100% '}
			px={2.5}
			mb={1.875}
			sx={claimListRowSX}
			gap={!isDesktop ? 2.5 : 0}
		>
			<Typography variant="value1" sx={headerTypographySX} textAlign={'start'}>
				{tClientLabels('forms.header.claimId')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.dateOfService')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.retailAmount')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.contractualWriteOff')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.memberPay')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.planPay')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.tax')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.retailNetOfTax')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.eyemedFeeNetOfTax')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.eyemedFeeTax')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.totalEyemedFee')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.pswtAmount')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.netAmountPaid')}
			</Typography>
			<Typography variant="value1" sx={{ minWidth: '140px', maxWidth: '140px' }}>
				{tClientLabels('forms.header.location')}
			</Typography>
			<Typography variant="value1" sx={headerTypographySX}>
				{tClientLabels('forms.header.eyemedFeeInvoice')}
			</Typography>
		</Stack>
	);
};

export default PaymentClaimsHeader;
